import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { navigateToHomeSection } from '../utils/navigation';

const CTA = () => {
  const [ctaRef, ctaVisible] = useScrollAnimation(0.3);

  const scrollToContact = () => {
    navigateToHomeSection('contact');
  };

  return (
    <section className="relative py-24 bg-black overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(37,99,235,0.32)_0%,rgba(15,23,42,0.72)_38%,rgba(0,0,0,1)_80%)] animate-gradient"></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-700/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div
        ref={ctaRef}
        className={`relative max-w-5xl mx-auto px-6 lg:px-20 text-center scroll-scale ${ctaVisible ? 'visible' : ''}`}
      >
        <div className="space-y-8">
          {/* Main Headline */}
          <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight tracking-tight">
            Ready to Automate Your Space?
          </h2>

          {/* Subtext */}
          <p className="body-large text-white/85 max-w-2xl mx-auto">
            Transform your home or business with intelligent automation solutions.
            Get a free consultation and custom quote from our expert team today.
          </p>

          {/* CTA Button */}
          <div className="pt-8">
            <button
              onClick={scrollToContact}
              className="btn-primary cta-button-glow group text-xl px-14 py-7"
            >
              Request a Solution
              <ArrowRight className="group-hover:translate-x-2 transition-transform" size={24} />
            </button>
          </div>

          {/* Additional Info */}
          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-8 text-white/75">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
              <span className="body-medium">Free Consultation</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              <span className="body-medium">Custom Solutions</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
              <span className="body-medium">Expert Team</span>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes gradient {
          0%, 100% {
            opacity: 0.3;
          }
          50% {
            opacity: 0.6;
          }
        }

        .animate-gradient {
          animation: gradient 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default CTA;
